
namespace TabAurous.Inventory {

    @Serenity.Decorators.registerClass()
    export class LotCreationItemsGrid extends Serenity.EntityGrid<LotCreationItemsRow, any> {
        protected getColumnsKey() { return 'Inventory.LotCreationItems'; }
        protected getDialogType() { return LotCreationItemsDialog; }
        protected getIdProperty() { return LotCreationItemsRow.idProperty; }
        protected getInsertPermission() { return LotCreationItemsRow.insertPermission; }
        protected getLocalTextPrefix() { return LotCreationItemsRow.localTextPrefix; }
        protected getService() { return LotCreationItemsService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}